export default class DiplomaApiService {
  _getCsrfToken() {
    return document.querySelector('meta[name="csrf-token"]')?.content;
  }

  async uploadImage(file, uploadPath) {
    const formData = new FormData();
    formData.append('image', file);

    return this._upload(formData, uploadPath);
  }

  async uploadAssetImage(assetPath, uploadPath) {
    const formData = new FormData();
    formData.append('asset_path', assetPath);

    return this._upload(formData, uploadPath);
  }

  async _upload(formData, uploadPath) {
    formData.append('authenticity_token', this._getCsrfToken());

    try {
      const response = await fetch(uploadPath, { method: 'POST', body: formData });
      const result = await response.json();

      if (response.ok) {
        return {
          success: true,
          imageUrl: result.image_url,
          blobId: result.blob_id
        };
      } else {
        return { success: false };
      }
    } catch (error) {
      return { success: false };
    }
  }
}
